import React, { useState } from 'react';
import {Redirect} from 'react-router';

import { AzureAuthenticatedEnvironment } from 'security/component/azure/AzureAuthenticatedEnvironment';
import { ApplicationRootUrl } from 'common/component/ApplicationRootContext';
import { getProviderViewAsSessionGuid } from './core/persistence/provider-view-as-state-magement';

type InternalUserProviderAppProps = {
    children: React.ReactNode;
    app: 'client-placement' | 'user-management';
}

export const InternalUserProviderViewAs = ({children, app}: InternalUserProviderAppProps) => {
    // get internal-provider-guid from session storage
    const internalProviderGuid = getProviderViewAsSessionGuid();
    const [providerGuid, setProviderGuid] = useState(internalProviderGuid);
    const rootUrl = app === 'client-placement' ? ApplicationRootUrl.AZURE_INTERNAL_CP_ROUTE_NAME : ApplicationRootUrl.AZURE_INTERNAL_UM_ROUTE_NAME;

    if (!internalProviderGuid) {
        return <Redirect to={`/${rootUrl}/select-provider`}/>
    }
    return (
        <InternalUserProviderViewAsContext.Provider value={{providerGuid, setProviderGuid}}>
            <AzureAuthenticatedEnvironment providerGuid={providerGuid ?? ''}>
                {children}
            </AzureAuthenticatedEnvironment>
        </InternalUserProviderViewAsContext.Provider>
    )
}

export const InternalUserProviderViewAsContext = React.createContext({
  providerGuid: null as string | null,
  setProviderGuid: (providerGuid: string) => {}
});